import Router from '../Router';

export default function () {
  return (
    <>
      {/* <BreadCrumb /> */}
      <Router />
    </>
  );
}
